import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableListEnginPage = withAsyncLoading(async () =>
    import('./ListEnginPage').then((res) => res.ListEnginPage)
);

export { LoadableListEnginPage };
